export const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') {
            removeEmpty(obj[key])
        } else if (obj[key] == null || obj[key] === "" || (Array.isArray(obj[key]) && obj[key].length === 0)) {
            delete obj[key];
        }
    });
};